{
  "info": "Informacije",
  "negative": "Greška",
  "notice": "Upozorenje",
  "positive": "Uspešno"
}
